<template>
  <div
    v-if="stateCurrentItem && stateCurrentItem._id"
    class="yt-student-detail"
  >
    <!-- <iframe src="http://cm.localhost.com" frameborder="0"></iframe> -->
    <div class="yt-student-main-form">
      <div class="yt-student-rate d-flex align-items-center mb-4">
        <div class="yt-student-thumb mr-3">
          <img
            v-if="stateCurrentItem.photo"
            class="rounded-circle"
            :alt="fullname"
            :src="`${baseUrl}uploads/${stateCurrentItem.photo}`"
          />
          <i class="far fa-user-circle" v-else></i>
        </div>
        <div class="yt-student-name">
          <h1 class="text-primary">
            Student Detail <i>({{ fullname }})</i>
          </h1>
          <ModalComponent
            class="yt-rate-button"
            :isButton="false"
            :width="1024"
            :id="stateCurrentItem._id"
            :component="modalRateDetail()"
          >
            <div class="d-flex">
              <div class="rate-icon text-center">
                <i class="far fa-thumbs-up"></i> <br />
                <span class="rate-number">{{ positiveRates }}</span>
              </div>
              <div class="rate-icon text-center ml-1">
                <i class="far fa-thumbs-down"></i> <br />
                <span class="rate-number">{{ negativeRates }}</span>
              </div>
            </div>
          </ModalComponent>
        </div>
      </div>

      <vue-form-generator
        class="row"
        ref="formData"
        :schema="schema"
        :model="formData"
        :options="formOptions"
        @model-updated="onModelUpdated"
      />
      <!-- :model="dataSelectedRow" :options="formOptions" :isNewModel="isNewModel" @validated="onValidated" @model-updated="onModelUpdated" -->

      <ButtonLoader
        class="btn btn-lg btn-success"
        :loading="loading"
        @onClick="onSaveItem"
        >Save</ButtonLoader
      >
    </div>

    <div
      v-if="stateCurrentItem.tutor && stateCurrentItem.tutor._id"
      class="yt-student-detail-subpanel mt-4"
    >
      <hr />
      <StudentSubjectList :id="stateCurrentItem.tutor._id" :key="id" />
    </div>

    <div class="yt-student-detail-subpanel mt-4 mb-3">
      <hr />
      <h2>Lessons</h2>
      <div>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Learning" active>
              <StudentLessonList :filter="{ studentId: id }" :key="id" />
            </b-tab>
            <b-tab
              v-if="stateCurrentItem.tutor && stateCurrentItem.tutor._id"
              title="Teaching"
            >
              <TeachingLessonList
                :filter="{
                  tutorId: stateCurrentItem.tutor._id
                }"
                :key="id"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VueFormGenerator from 'vue-form-generator'
import { baseUrl } from '@/config'

import StudentSubjectList from '@/components/students/_StudentSubjectList'
import StudentLessonList from '@/components/students/_StudentLessonList'
import TeachingLessonList from '@/components/students/_TeachingLessonList'

const appModule = namespace('app')
const itemsModule = namespace('items')
const subjectsModule = namespace('subjects')

@Component({
  components: {
    StudentSubjectList,
    StudentLessonList,
    TeachingLessonList
  }
})
export default class StudentDetail extends Vue {
  @appModule.State('schools') stateSchools
  @itemsModule.State('currentItem') stateCurrentItem
  @subjectsModule.State('grades') stateCurrentGrades

  @itemsModule.Mutation('setCurrentItem') mutationCurrentItem
  @subjectsModule.Mutation('setGrades') mutationGrades

  @itemsModule.Action('getItem') actionGetItem
  @itemsModule.Action('update') actionUpdate
  @subjectsModule.Action('getGrades') actionGetGrades

  @Prop({
    type: String,
    required: true,
    default: null
  })
  id

  formOptions = {
    validateAfterLoad: true,
    validateAfterChanged: true,
    validateAsync: false,
    validateDebounceTime: 300
  }

  loading = false
  baseUrl = baseUrl
  formData = {}

  schema = {
    groups: [
      {
        legend: 'Personal Information',
       // legend: 'Main Information',
        styleClasses: 'col-md-6',
        fields: [
          {
            // label: 'ID (disabled text field)',
            model: '_id',
            type: 'input',
            inputType: 'hidden',
            readonly: true
            // disabled: true
          },
          {
            label: 'First Name',
            model: 'firstName',
            type: 'input',
            inputType: 'text',
            placeholder: 'First name',
            required: true,
            validator: ['string']
          },
          {
            label: 'Last Name',
            model: 'lastName',
            type: 'input',
            inputType: 'text',
            placeholder: 'Last Name',
            required: true,
            validator: ['string']
          },
          {
            label: 'Parent/Guardian Email',
            model: 'parentGuardianEmail',
            type: 'input',
            inputType: 'email',
            placeholder: 'Enter Parent Email',
            validator: ['email']
          },
          {
            label: 'New Password',
            model: 'password',
            type: 'input',
            inputType: 'password',
            placeholder: 'Enter New Password',
            min: 8,
            validator: ['validatePassword']
          },
          {
            label: 'Password Confirmation',
            model: 'confirmPassword',
            type: 'input',
            inputType: 'password',
            placeholder: 'Confirm Password',
            // minlength: 4,
            validator: ['confirmEqualValidator'], // ['confirmEqualValidator'],
            confirmField: {
              field: 'password',
              message: 'Password confirmation is invalid.'
            }
          }
        ]
      },
      {
        legend: 'School Information',
        styleClasses: 'col-md-6',
        fields: [
          {
            label: 'Email',
            model: 'schoolEmail',
            type: 'input',
            inputType: 'email',
            placeholder: 'Enter Email',
            validator: ['email']
          },
          {
            label: 'Domain',
            model: 'schoolId',
            type: 'select',
            featured: true,
            required: true,
            // values: function () {
            //     return [
            //         { id: 'superadmin', name: 'Super Admin' }
            //     ]
            // },
            validator: VueFormGenerator.validators.required.locale({
              fieldIsRequired: 'School is required!'
            }),
             placeholder: 'Select Domain',
             selectOptions: {

              noneSelectedText: 'Select Domain', // Text shown for placeholder
            },
            // disabled: true
          },
          {
            label: 'Grade',
            model: 'gradeId',
            type: 'select',
            featured: true,
            required: true,
             placeholder: 'Select Grade',
            validator: VueFormGenerator.validators.required.locale({
              fieldIsRequired: 'Grade is required!'
            }),
             selectOptions: {

              noneSelectedText: 'Select Grade', // Text shown for placeholder
            },
            
          },
          {
            label: 'Account Activated',
            model: 'user.isAccountActive',
            type: 'switch',
            default: false,
            textOn: 'Active',
            textOff: 'Inactive'
          },
          {
            label: 'Active',
            model: 'user.isActive',
            type: 'switch',
            default: false,
            textOn: 'Active',
            textOff: 'Inactive'
          }
        ]
      }
    ]
  }

  mounted() {
    this.actionGetItem({ path: 'studentsCms', id: this.id })
  }

  destroyed() {
    this.mutationCurrentItem({})
  }

  @Watch('stateSchools', { immediate: true })
  loadSchools() {
    this.getSchemaField('schoolId').values = () => {
      return this.stateSchools
    }
  }

  @Watch('stateCurrentItem', { immediate: false })
  getGrades() {
    this.actionGetGrades(this.stateCurrentItem.school._id)
    const schoolId =
      this.stateCurrentItem &&
      this.stateCurrentItem.school &&
      this.stateCurrentItem.school._id
    const gradeId =
      this.stateCurrentItem &&
      this.stateCurrentItem.grade &&
      this.stateCurrentItem.grade._id
    this.formData = { ...this.stateCurrentItem, schoolId, gradeId }
  }

  @Watch('stateCurrentGrades', { immediate: true })
  loadGrades() {
    this.getSchemaField('gradeId').values = () => {
      return this.stateCurrentGrades
    }
  }

  get fullname() {
    return `${this.stateCurrentItem.firstName} ${
      this.stateCurrentItem.lastName
    }`
  }

  get positiveRates() {
    return (
      (this.stateCurrentItem.tutor &&
        this.stateCurrentItem.tutor.totalPositiveRates) ||
      this.stateCurrentItem.totalPositiveRates
    )
  }

  get negativeRates() {
    return (
      (this.stateCurrentItem.tutor &&
        this.stateCurrentItem.tutor.totalNegativeRates) ||
      this.stateCurrentItem.totalNegativeRates
    )
  }

  getSchemaField(key) {
    let field

    this.schema.groups.map(item => {
      field = item.fields.find(field => field.model === key)
    })

    return field
  }

  onModelUpdated(newVal, schema) {
    if (schema === 'schoolId') {
      this.mutationGrades([])
      this.actionGetGrades(newVal)
    }
  }

  onSaveItem() {
    if (this.$refs.formData.validate()) {
      this.loading = true
      this.actionUpdate({
        path: 'studentsCms',
        id: this.id,
        data: this.formattedData()
      })
        .then(() => {
          this.loading = false
        })
        .catch(response => {
          this.loading = false
          this.$modal.show('dialog', {
            title: 'Error!',
            text: response.message.data
          })
        })
    }
  }

  modalRateDetail() {
    return this.stateCurrentItem
      ? {
          modalTitle: 'Rate Detail',
          component: () => import('@/components/students/_RateDetail'),
          componentProps: {
            tutorId:
              this.stateCurrentItem.tutor && this.stateCurrentItem.tutor._id,
            studentId: this.stateCurrentItem._id
          }
        }
      : null
  }

  formattedData() {
    let dataFormatted = {}

    this._.map(this.schema.groups, group => {
      this._.map(group.fields, item => {
        dataFormatted[item.model] = this._.get(this.formData, item.model)
      })
    })

    return dataFormatted
  }
}
</script>

<style scoped lang="scss">
.yt-student-detail {
  text-align: left;

  .yt-student-thumb {
    font-size: 5em;
    line-height: 1;
    height: 100px;
    overflow: hidden;
    width: 100px;

    img {
      font-size: 0.325em;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  .yt-rate-button {
    cursor: pointer;
  }

  .rate-icon {
    font-size: 1.4em;
    line-height: 1;
  }

  .rate-number {
    font-size: 0.6em;
    line-height: 1;
  }

  /deep/ fieldset {
    legend {
      font-size: 1.325rem;
    }
  }

  /deep/ .form-group {
    &.readonly {
      &.field-input {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/students/StudentDetail.vue